<div class="cart-content-shell" [class.cart-content-dropdown]="isDropdown">
  <div class="cart-content">
    @if (items.length === 0) {
      <div class="cart-empty-state">{{ 'cartIsEmpty' | translate }}</div>
    } @else {
      <div class="cart-items">
        @for (item of items; track item.productId; let i = $index) {
          <div class="cart-item">
            <a
              class="cart-item-thumbnail"
              [routerLink]="[userStorageRoutes.Overview, item.productId]"
              (click)="close()"
            >
              <span class="cdk-visually-hidden">{{ item.name }}</span>
              @if (item.schematicImage?.link) {
                <img
                  [src]="item.schematicImage?.link | appendDomain"
                  [alt]="item.schematicImage?.name || item.name"
                />
              } @else {
                <mat-icon class="cart-item-thumbnail-placeholder">image</mat-icon>
              }
            </a>
            <div class="cart-item-details">
              <h3>
                <a
                  class="cart-item-product-link"
                  [routerLink]="[userStorageRoutes.Overview, item.productId]"
                  (click)="close()"
                >
                  {{ item.name }}{{ item.articleNo ? ' (' + item.articleNo + ')' : '' }}
                </a>
              </h3>
            </div>
            <div class="cart-item-quantity-container">
              <app-ui-input
                class="cart-item-quantity"
                label="{{ 'quantity' | translate }}"
                type="number"
                [required]="true"
                [control]="getQuantityControl(i)"
                (changeHandler)="quantityInputChanged(i, $event)"
              ></app-ui-input>
              @if (item.quantityType?.name; as quantityTypeName) {
                <app-text-overflow-label
                  class="cart-item-quantity-type"
                  [text]="quantityTypeName"
                ></app-text-overflow-label>
              }
            </div>
            <app-ui-button
              buttonType="icon-button"
              icon="delete"
              tooltip="{{ 'removeFromCart' | translate }}"
              (click)="removeFromCart(item.productId)"
            ></app-ui-button>
          </div>
        }
      </div>
    }
  </div>

  <div class="cart-actions">
    <div class="cart-actions-content">
      @if (items.length > 0) {
        <app-ui-button
          appConfirmDialog
          buttonType="secondary"
          text="{{ 'clearCart' | translate }}"
          [confirmTitle]="'clearCart' | translate"
          [confirmMessage]="'clearCartConfirm' | translate"
          confirmButtonText="clearCart"
          confirmButton="warn-secondary"
          [ownPunctuationMark]="true"
          (confirmed)="clearCart()"
        ></app-ui-button>
      }
      <span class="cart-actions-spacer"></span>
      <app-ui-button
        buttonType="secondary"
        text="{{ 'cancel' | translate }}"
        (click)="close()"
      ></app-ui-button>
      <app-ui-button
        text="{{ 'makeOrder' | translate }}"
        icon="arrow_drop_down"
        iconPosition="right"
        [disabled]="makeOrderDisabled"
        [privilege]="makeOrderPrivileges"
        [tooltip]="makeOrderTooltip"
        [matMenuTriggerFor]="makeOrderMenu"
      ></app-ui-button>
      <mat-menu #makeOrderMenu="matMenu">
        <span
          class="cart-menu-item-tooltip-target"
          [matTooltip]="canCreateOrder ? '' : ('noAccess' | translate)"
          [matTooltipDisabled]="canCreateOrder"
        >
          <button
            mat-menu-item
            type="button"
            [disabled]="!canCreateOrder"
            (click)="makeNewDraftOrder()"
          >
            {{ 'newDraftOrder' | translate }}
          </button>
        </span>
        <span
          class="cart-menu-item-tooltip-target"
          [matTooltip]="canUpdateOrder ? '' : ('noAccess' | translate)"
          [matTooltipDisabled]="canUpdateOrder"
        >
          <button
            mat-menu-item
            type="button"
            [disabled]="!canUpdateOrder"
            (click)="addToExistingDraft()"
          >
            {{ 'addToExistingDraft' | translate }}
          </button>
        </span>
        @if (canAddToCurrentDraft) {
          <span
            class="cart-menu-item-tooltip-target"
            [matTooltip]="canUpdateOrder ? '' : ('noAccess' | translate)"
            [matTooltipDisabled]="canUpdateOrder"
          >
            <button
              mat-menu-item
              type="button"
              [disabled]="!canUpdateOrder"
              (click)="addToCurrentDraft()"
            >
              {{ 'addToThisDraft' | translate }}
            </button>
          </span>
        }
      </mat-menu>
    </div>
  </div>
</div>
